import { DiscountTypes } from '@invivodf/module-discount-sdk'

export enum FilterStatusOption {
  Upcoming = 'a_venir',
  Active = 'en_cours',
  Expired = 'archivee',
}

export interface ListingFilter {
  keyWord?: string
  status?: FilterStatusOption
  discountType?: DiscountTypes
}
